// Mock data for SAGU CONSTRUCTION LLC

export const businessInfo = {
  name: "SAGU CONSTRUCTION LLC",
  phone: "(407) 558-6500",
  whatsapp: "+14075586500",
  email: "saguremodeling@gmail.com",
  location: "Orlando, FL",
  hours: "Mon-Thu: 7 AM - 5 PM | Fri: 7 AM - 3 PM",
  rating: 5.0,
  reviewCount: 55,
  instagram: "@saguremodeling",
  googleReviewsUrl: "https://www.google.com/search?q=SAGU+CONSTRUCTION+LLC",
  description: "Licensed & Insured Florida LLC with over 10 years of experience in residential and commercial construction. We've proudly completed over 5,000 projects across Orlando, Kissimmee, and surrounding areas."
};

export const services = [
  {
    id: 1,
    title: "Smooth Stucco",
    description: "Premium stucco finishes that last for decades",
    icon: "Home"
  },
  {
    id: 2,
    title: "Drywall & Texture",
    description: "Perfect walls with professional texture application",
    icon: "Square"
  },
  {
    id: 3,
    title: "Interior & Exterior Painting",
    description: "High-quality paints and flawless application",
    icon: "Paintbrush"
  },
  {
    id: 4,
    title: "Masonry / Block / Concrete",
    description: "Durable concrete and masonry work",
    icon: "Building"
  },
  {
    id: 5,
    title: "Residential & Commercial Repairs",
    description: "Complete repair services for any property",
    icon: "Wrench"
  }
];

export const beforeAfterProjects = [
  {
    id: 1,
    title: "Custom Shed - Block & Stucco",
    before: "https://customer-assets.emergentagent.com/job_florida-remodel/artifacts/nx4l6tp4_after%2001.jpeg",
    after: "https://customer-assets.emergentagent.com/job_florida-remodel/artifacts/j3rb9wzo_before%2001.jpeg"
  },
  {
    id: 2,
    title: "Three-Car Garage - Complete Stucco Finish",
    before: "https://customer-assets.emergentagent.com/job_florida-remodel/artifacts/pvummfmr_after%2002.jpeg",
    after: "https://customer-assets.emergentagent.com/job_florida-remodel/artifacts/h5hajvav_before%2002.jpeg"
  },
  {
    id: 3,
    title: "Residential Exterior Transformation",
    before: "https://customer-assets.emergentagent.com/job_florida-remodel/artifacts/c65iaoe0_after%2003.jpeg",
    after: "https://customer-assets.emergentagent.com/job_florida-remodel/artifacts/nm8wj3y8_before%2003.jpeg"
  },
  {
    id: 4,
    title: "Modern Home Exterior Remodel",
    before: "https://customer-assets.emergentagent.com/job_florida-remodel/artifacts/rkal6tup_after%2004.jpeg",
    after: "https://customer-assets.emergentagent.com/job_florida-remodel/artifacts/gvnoj82n_before%2004.jpeg"
  }
];

export const benefits = [
  "Licensed & Insured (COI available upon request)",
  "Free & fast estimates",
  "10 years serving Florida homeowners",
  "Residential and commercial expertise",
  "Over 5,000 projects completed"
];

export const reviews = [
  {
    id: 1,
    name: "Maria Rodriguez",
    rating: 5,
    date: "2 weeks ago",
    text: "Excellent work! They repaired our stucco and painted the exterior. The crew was professional, punctual, and cleaned up perfectly. Highly recommend SAGU CONSTRUCTION!"
  },
  {
    id: 2,
    name: "John Smith",
    rating: 5,
    date: "1 month ago",
    text: "Outstanding service from start to finish. They transformed our kitchen with beautiful new walls and paint. The quality is superb and the price was very fair."
  },
  {
    id: 3,
    name: "Carlos Martinez",
    rating: 5,
    date: "1 month ago",
    text: "SAGU did an amazing job on our home renovation. The team was respectful, efficient, and their attention to detail is impressive. Will definitely use them again!"
  },
  {
    id: 4,
    name: "Jennifer Taylor",
    rating: 5,
    date: "2 months ago",
    text: "Best remodeling company in Orlando! They completed our bathroom renovation quickly and the results exceeded our expectations. Very professional team."
  },
  {
    id: 5,
    name: "David Anderson",
    rating: 5,
    date: "3 months ago",
    text: "I hired SAGU for exterior painting and masonry work. They were fantastic! Great communication, quality work, and competitive pricing. Couldn't be happier!"
  },
  {
    id: 6,
    name: "Lisa Johnson",
    rating: 5,
    date: "3 months ago",
    text: "Professional and reliable service. They fixed our damaged drywall and did a complete interior paint job. The house looks brand new! Thank you SAGU!"
  }
];
